import { gsap } from 'gsap'
import Experience from '../Experience.js'

// Plan du parcours : vue orthographique d'ensemble, les 18 repères de
// trou visibles et les tracés départ -> green. Un clic sur un repère
// ramène la visite guidée sur ce trou.
export default class MapView {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.camera = this.experience.camera
        this.labels = this.experience.labels

        this.active = false

        this.camera.setMapPoints([
            ...this.labels.holeLabels.map(l => l.top),
            ...this.labels.teeLabels.map(l => l.base)
        ])

        this.bindEvents()
    }

    // Les repères de trou sont cliquables (CSS : body.map-mode)
    bindEvents() {
        this.onClick = (event) => {
            if (!this.active) return
            const marker = event.target.closest('.marker--hole')
            if (marker) this.experience.modeToggle?.goToHole(Number(marker.dataset.hole))
        }
        this.labels.container?.addEventListener('click', this.onClick)
    }

    show() {
        this.active = true

        this.labels.showHolesOnly()
        this.experience.ballTrajectory?.showOverview()

        // Le brouillard est calibré pour la caméra embarquée : à la
        // distance du plan il noierait tout le parcours.
        const fog = this.scene.fog
        if (fog) {
            this.savedFog = { near: fog.near, far: fog.far }
            fog.near = 100
            fog.far = 200
        }

        // Léger travelling avant à l'ouverture du plan
        const ortho = this.camera.orthographic
        gsap.killTweensOf(ortho)
        ortho.zoom = 0.85
        gsap.to(ortho, {
            zoom: 1,
            duration: 1.1,
            ease: 'power3.out',
            onUpdate: () => ortho.updateProjectionMatrix()
        })
    }

    hide() {
        if (!this.active) return
        this.active = false
        gsap.killTweensOf(this.camera.orthographic)

        if (this.savedFog && this.scene.fog) {
            this.scene.fog.near = this.savedFog.near
            this.scene.fog.far = this.savedFog.far
        }

        const timeline = this.experience.timeline
        this.experience.ballTrajectory?.hideOverview(timeline.progress)
        timeline.updateHoleActivation()
    }

    destroy() {
        this.labels.container?.removeEventListener('click', this.onClick)
        this.experience = null
    }
}
